import { RecordScreenFormCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenFormCard";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateRelocationMutation } from "@/app/Relocations/GraphQL/relocationMutations";
import { useRelocationRecord } from "@/app/Relocations/Hooks/useRelocationRecord";
import { DateBadgeInput } from "@/lib/Components/Form/Inputs/DateBadgeInput";
import { CalendarDaysIcon } from "@heroicons/react/20/solid";

type OpenDatesFormValues = {
  open_departure_dates: string[];
  open_delivery_dates: string[];
};

/**
 * Dates the supplier opens for this deal even though the office is normally
 * closed then. The office's usual hours apply on the day.
 */
export function OpenDatesFormCard() {
  const { mutateAsync } = useGqlMutation(updateRelocationMutation);
  const record = useRelocationRecord();

  const initialValues: OpenDatesFormValues = {
    open_departure_dates: record.open_departure_dates ?? [],
    open_delivery_dates: record.open_delivery_dates ?? [],
  };

  return (
    <RecordScreenFormCard<OpenDatesFormValues>
      containerClassName="rounded-lg border border-gray-200 bg-white p-6"
      enableReinitialize={true}
      title={
        <div className="flex items-center gap-3">
          <div className="rounded-lg bg-emerald-100 p-2">
            <CalendarDaysIcon className="h-5 w-5 text-emerald-600" />
          </div>
          <div>
            <div>Extra open dates</div>
            <p className="text-sm font-normal text-gray-500">
              Dates this deal can be picked up or dropped off on even though the
              office is closed. The office&apos;s usual hours apply.
            </p>
          </div>
        </div>
      }
      initialValues={initialValues}
      onSubmit={async (values) => {
        await mutateAsync({
          id: record.id,
          input: {
            open_departure_dates: values.open_departure_dates,
            open_delivery_dates: values.open_delivery_dates,
          },
        });
      }}
    >
      <DateBadgeInput
        className="col-span-full"
        name="open_departure_dates"
        label="Pickup dates"
        min={record.available_from_date}
        max={record.available_to_date}
      />
      <DateBadgeInput
        className="col-span-full"
        name="open_delivery_dates"
        label="Dropoff dates"
        min={record.available_from_date}
        max={record.available_to_date}
      />
    </RecordScreenFormCard>
  );
}
